import React, { Component, useRef  } from 'react';
import ActionsContextV2 from '../ActionsContextV2';
import { CSVLink } from 'react-csv';
 
const headers = [
  { label: "Approval Type", key: "approvalType" },
  { label: "SDN", key: "sdn" },
  { label: "Title", key: "title" },
  { label: "Category", key: "category" },
  { label: "Rev", key: "rev" },
  { label: "Compliance", key: "compliance" },
  { label: "Reasoning", key: "reasoning" },
  { label: "Status", key: "status" },
  { label: "Pending With", key: "pendingWith" }
];
 
let data = [];
let filename = '';

const ActionsExportProceduresV2 = () => {
  const context = React.useContext(ActionsContextV2);
  const csvLink = useRef() // setup the ref that we'll use for the hidden CsvLink click once we've updated the data

  // build data
  data = [];
  const {pendingActions, approvedActions, projectName, functionName} = context.actionsRedux.selectedProjectFunctionDetails;
  filename = projectName + '-' + functionName + ' - Procedures.csv';
  pendingActions.forEach((pe) => {
    const workflowSteps = pe.workflowSteps.filter(ws => {return ws.assigneeBun === pe.assigneeBun;});
    data.push({
      approvalType: pe.approvalType, sdn: pe.procedureSdn, title: pe.procedureName, category: pe.categoryName,
        rev: pe.rev, compliance: pe.applicability, reasoning: pe.deviationReasoning, status: pe.status, pendingWith: workflowSteps.length > 0 ? workflowSteps[0].assignee : ''
    });
  });
  approvedActions.forEach((aa) => {
    data.push({
      approvalType: aa.approvalType, sdn: aa.procedureSdn, title: aa.procedureName, category: aa.categoryName,
        rev: aa.rev, compliance: aa.applicability, reasoning: aa.deviationReasoning, status: aa.status, pendingWith: ''
    });
  });
  
  // adding delay so that csv link is rendered before doing click event
  setTimeout(function() {
    if (csvLink && csvLink.current.link !== null) { csvLink.current.link.click(); }
    context.setDownloadProcedures(false);
  }.bind(this), 5000)
  

  return (
    <CSVLink 
      data={data} 
      headers={headers} 
      filename={filename}
      className='hidden'
      ref={csvLink}
      target='_blank'
    >
    </CSVLink>
  );
}

export default ActionsExportProceduresV2;
